import { currentMonth, currentYear } from '../util';

const Api = {
  valuate(contentId) {
     return fetch(`/api/valuation/content/${contentId}/1`, { method: 'POST' })
       .then((res) => res.json())
       .catch(() => ({ success: false }));
   },
  undoValuation(contentId) {
     return fetch(`/api/valuation/content/${contentId}`, { method: 'DELETE' })
       .then((res) => res.json())
       .catch(() => ({ success: false }));
  },
  checkContents() {
    localStorage.setItem(`valuation_in_progress_likes_${currentYear}_${currentMonth}`, 1);
    // +1 porque empieza a contar desde 0, así enero sería el mes 0
    return fetch(`/api/user/getuserlikes/${currentYear}/${currentMonth}/`)
      .then((res) => res.json());
  },
};

export default Api;
